__turbopack_context__.v({
  "background": "HeroSection-module__RRI0fq__background",
  "copyBlock": "HeroSection-module__RRI0fq__copyBlock",
  "decoration": "HeroSection-module__RRI0fq__decoration",
  "heroCta": "HeroSection-module__RRI0fq__heroCta",
  "heroMediaArea": "HeroSection-module__RRI0fq__heroMediaArea",
  "heroPoster": "HeroSection-module__RRI0fq__heroPoster",
  "heroSignalBand": "HeroSection-module__RRI0fq__heroSignalBand",
  "heroVideo": "HeroSection-module__RRI0fq__heroVideo",
  "location": "HeroSection-module__RRI0fq__location",
  "mediaFrame": "HeroSection-module__RRI0fq__mediaFrame",
  "overlay": "HeroSection-module__RRI0fq__overlay",
  "section": "HeroSection-module__RRI0fq__section",
  "statGroup": "HeroSection-module__RRI0fq__statGroup",
  "statItem": "HeroSection-module__RRI0fq__statItem",
  "statLabel": "HeroSection-module__RRI0fq__statLabel",
  "statValue": "HeroSection-module__RRI0fq__statValue",
  "statsRow": "HeroSection-module__RRI0fq__statsRow",
  "subtitle": "HeroSection-module__RRI0fq__subtitle",
  "title": "HeroSection-module__RRI0fq__title",
  "titleWrap": "HeroSection-module__RRI0fq__titleWrap",
});
